export interface ContactUsPayload {
  name: string;
  emailId: string;
  subject: string;
  phone: string;
  message: string;
}

interface ContactUsRequest extends ContactUsPayload {
  call_type: {
    callType: string;
  };
  clientKey: string;
  clientId: string;
  version: string;
}

const CLIENT_KEY =
  "48cac23e92f95b8972091bc2085ff5cdc2c745c4477e17ebfffb79627029f335";

const CLIENT_ID = "2016";
const VERSION = "2.0.0";

const getServerUrl = (): string => {
  const hostname = window.location.hostname;

  if (hostname.includes("v1.finsall.co.in")) {
    return "https://v1.finsall.co.in/FinsAllServer/contact";
  }

  if (hostname.includes("finsall.co.in")) {
    return "https://finsall.co.in/FinsAllServer/contact";
  }

  if (hostname.includes("finsall.com")) {
    return "https://finsall.com/FinsAllServer/contact";
  }

  return "https://finsall.co.in/FinsAllServer/contact";
};

export const submitContactUs = async (
  formData: ContactUsPayload
): Promise<any> => {
  const payload: ContactUsRequest = {
    call_type: {
      callType: "Contact Us",
    },
    name: formData.name.trim(),
    emailId: formData.emailId.trim(),
    subject: formData.subject.trim(),
    phone: formData.phone.trim(),
    message: formData.message.trim(),
    clientKey: CLIENT_KEY,
    clientId: CLIENT_ID,
    version: VERSION,
  };

  try {
   const response = await fetch(getServerUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error("Contact Us API Error:", error);

    return {
      success: false,
      error,
    };
  }
};